import React, { useEffect } from 'react';
import {
  QueryParameterNames,
  LogoutActions,
  ApplicationPaths
} from './ApiAuthorizationConstants';
import { Spinner } from '../Utils/Loaders';
import { useAuth } from '../../auth/AuthContext';

export interface IProps {
  action: string;
}

export const Logout = ({ action }: IProps) => {
  const { signoutRedirect, completeSignOut } = useAuth();

  const getReturnUrl = (returnUrl?: string) => {
    const params = new URLSearchParams(globalThis.location.search);
    const fromQuery = params.get(QueryParameterNames.ReturnUrl);
    if (fromQuery && !fromQuery.startsWith(`${globalThis.location.origin}/`)) {
      throw new Error(
        'Invalid return url. The return url needs to have the same origin as the current page.'
      );
    }
    return (
      returnUrl ||
      fromQuery ||
      `${globalThis.location.origin}${ApplicationPaths.LoggedOut}`
    );
  };

  useEffect(() => {
    const run = async () => {
      if (action === LogoutActions.Logout) {
        await signoutRedirect(getReturnUrl());
        return;
      }

      if (action === LogoutActions.LogoutCallback) {
        await completeSignOut(globalThis.location.href);
        globalThis.location.replace(getReturnUrl('/'));
        return;
      }

      if (action === LogoutActions.LoggedOut) {
        globalThis.location.replace(
          `${globalThis.location.origin}${ApplicationPaths.Login}`
        );
        return;
      }

      throw new Error(`Invalid action '${action}'`);
    };

    run();
  }, [action, completeSignOut, signoutRedirect]);

  return (
    <div>
      <Spinner />
    </div>
  );
};
